import request from '@/utils/request'

export function getBrands(params) {
    return request({
        url: '/brands',
        method: 'get',
        params
    })
}

export function getSeriesByBrandId(id, params) {
    return request({
        url: `/brand/${id}`,
        method: 'get',
        params
    })
}

export function getSeriesById(id, params) {
    return request({
        url: `/series/${id}`,
        method: 'get',
        params
    })
}

export function getSeriesImagesById(id, params) {
    return request({
        url: `/series/images/${id}`,
        method: 'get',
        params
    })
}

export function getSeriesNewsById(id, params) {
    return request({
        url: `/series/news/${id}`,
        method: 'get',
        params
    })
}

export function getSearchCars(params) {
    return request({
        url: '/car/search',
        method: 'get',
        params
    })
}